import GLightbox from "glightbox";
import Splide from "@splidejs/splide";
import Player from "@vimeo/player";
import Masonry from "masonry-layout";
import { ProportionalImageNormalisation } from "@keodesign/proportional-image-normalisation";

const bootstrap = window.bootstrap;
let fullMenuIsOpen = false;

export function init() {
	setupMapClick();
	setupLightbox();
	// setupTestimonialSlider();
	// setupContentSlider();
	setupOfferSlider();
	setupAutoHideMenu();
	setupCarousel();
	setupSliderWithImage();
	hijackSelectField();
	scrollAnimation();
	setupGalleryMasonry();
	setupFullMenu();
	ProportionalImageNormalisation(".scale-me", 125, 0.525);
	ProportionalImageNormalisation(".scale-me-smaller", 90, 0.525);
	setupDownloadwithForm();
}

export function setupDownloadwithForm(){
	const downloadLinks = document.querySelectorAll("a.download-form");
	const modalEl = document.getElementById("downloadModal");
	const modal = new bootstrap.Modal(modalEl);
	const fileUrlInput = document.getElementById("fileUrl");
	const downloadForm = document.getElementById("downloadForm");
	const formName = document.getElementById("formName");
	
	// Intercept all download-form links
	downloadLinks.forEach(link => {
		const href = link.getAttribute("href");
		link.removeAttribute("href"); // remove hyperlink
		link.style.cursor = "pointer";

		link.addEventListener("click", function (e) {
			e.preventDefault();
			fileUrlInput.value = href; // store original file URL

			document.querySelector(".modal-title").innerHTML = link.innerHTML;
			formName.value = link.innerHTML;
			modal.show();
		});
	});

	// Handle form submission
	downloadForm.addEventListener("submit", function (e) {
		e.preventDefault();

		const name = document.getElementById("userName").value.trim();
		const email = document.getElementById("userEmail").value.trim();
		const phone = document.getElementById("userPhone").value.trim();
		const fileUrl = fileUrlInput.value;

		if (!name || !phone || !email) {
			alert("Please fill in all fields.");
			return;
		}
		window.open(fileUrl, "_blank");
		modal.hide();
	
		downloadForm.submit();
	
	});
}

export function setupLightbox(){
	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
		plyr: {

			config: {
				ratio: "16:9", // or '4:3'
				muted: false,
				hideControls: true,
				youtube: {
					noCookie: true,
					rel: 0,
					showinfo: 0,
					iv_load_policy: 3
				},
				vimeo: {
					byline: false,
					portrait: false,
					title: true,
					speed: true,
					transparent: false
				}
			}
		}
	});

}

export function setupFullMenu() {
	const navLinks = document.querySelectorAll(".navbar-nav.depth-0 > .nav-item > .btn-group > a.nav-link");
	const fullMenu = document.querySelector("#full-menu");
	const submenuWrapper = document.getElementById("submenu-wrapper");
	
	const closeBtn = document.createElement("button");
	closeBtn.innerHTML = "✕"; // Unicode 'X' character
	closeBtn.classList.add("close-btn");
	closeBtn.addEventListener("click", () => {
		fullMenu.classList.remove("show");
		fullMenuIsOpen = false;
	});

	navLinks.forEach(link => {
		link.addEventListener("click", (event) => {
			fullMenuIsOpen = true;
			event.preventDefault(); // Prevent default link behavior
			
			const ulSibling = link.nextElementSibling;
			submenuWrapper.innerHTML = ""; 
			submenuWrapper.appendChild(closeBtn);

			const linkClone = link.cloneNode(true);
			linkClone.classList.add("fade-in-element");
			setTimeout(() => {
				linkClone.classList.add("visible");
			}, 400);


			submenuWrapper.appendChild(linkClone);
			if (ulSibling && ulSibling.tagName === "UL") {
				const ulClone = ulSibling.cloneNode(true);

				const ulClone_list = ulClone.querySelectorAll(":scope > li");
				let delay = 400;
				ulClone_list.forEach(listItem => {
					listItem.classList.add("fade-in-element");
					delay = delay + 200;
					setTimeout(() => {
						listItem.classList.add("visible");
					}, delay);
				});
				ulClone.classList.remove("dropdown-menu");
				submenuWrapper.appendChild(ulClone);
			}
			fullMenu.classList.toggle("show");
		});
	});

	fullMenu.addEventListener("click", (event) => {
		if (event.target === fullMenu) {
			fullMenu.classList.remove("show");
			fullMenuIsOpen = false;
		}
	});
}

export function setupGalleryMasonry(){

	var elem = document.querySelector(".masonry-layout");
	if(elem){
		new Masonry( elem, {
			itemSelector: ".grid-item",
			columnWidth: ".grid-sizer",
			percentPosition: true
	
		});
	}
}
export function scrollAnimation() {

	const observer = new IntersectionObserver((entries) => {
		let delay = 0; // default delay for elements without reset-fade class
		entries.forEach(entry => {
			const el = entry.target;

			if (entry.isIntersecting) {
				if (el.classList.contains("reset-fade")){
					delay = 0; // reset delay for elements with reset-fade class
				}
				else
				{
					delay = delay + 200; // 100ms between each element
				}
				el.style.transitionDelay = `${delay}ms`;
				entry.target.classList.add("visible");
				observer.unobserve(el);

			}
			// else{
			// 	el.style.transitionDelay = "0ms"; // reset delay

			// 	entry.target.classList.remove("visible");
			// }
		});
	}, {
		threshold: 0.33 // You can tweak this for sensitivity
	});

	document.querySelectorAll(".fade-in-element").forEach(el => {
		observer.observe(el);
	});
}


export function hijackSelectField() {
	const selects = document.querySelectorAll("select");

	selects.forEach(function (select) {
		const removeName = () => {
			if (select.value.trim() === "") {
				select.removeAttribute("name");
			} else {
			// Restore name attribute if it was previously removed
				if (!select.hasAttribute("name") && select.dataset.originalName) {
					select.setAttribute("name", select.dataset.originalName);
				}
			}
		};
		select.addEventListener("change", removeName);
		
			
		// Save original name in case we need to restore it later
		if (select.hasAttribute("name")) {
			select.dataset.originalName = select.getAttribute("name");
			removeName();
		}

	});
}


export function setupSliderWithImage(){

	function updateGraphicFromSlide(slide, imageEl) {
		const graphicSpan = slide.querySelector("[data-graphic-url]");

		if (graphicSpan) {
			const url = graphicSpan.getAttribute("data-graphic-url");
			const alt = graphicSpan.getAttribute("data-graphic-name");

			// Check if an img already exists
			let img = imageEl.querySelector("img");

			if (!img) {
				// Create the image if it doesn't exist
				img = document.createElement("img");
				img.classList.add("img-fluid");
				imageEl.appendChild(img);
			}

			if (url && (img.src !== url)) {
				imageEl.classList.add("fade-out");

				// Wait for fade-out to finish, then update src and fade back in
				setTimeout(() => {
					img.src = url;
					if (alt){
						img.alt = alt;
					}
					// Once image loads, fade it back in
					img.onload = () => {
						imageEl.classList.remove("fade-out");
					};
				}, 500); // shorter than transition time for a smoother effect
			}
		} else {
			// Optional: remove img if no graphic is found
			const existingImg = imageEl.querySelector("img");
			if (existingImg) {
				imageEl.classList.add("fade-out");
				setTimeout(() => {
					imageEl.classList.remove("fade-out");
					imageEl.removeChild(existingImg);
				}, 500);
			
			}
		}

		
	}

	const Slider = document.querySelectorAll(".content-slider");
	
	if(Slider){
		for (var i = 0; i < Slider.length; i++ ) {
			var slider = Slider[i].querySelector(".slider");
			if (!slider){
				continue;
			}
			const splide = new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			});

			const imageEl = Slider[i].querySelector(".graphic-image-container");
			// Update on mount
			splide.on("mounted", () => {
				const currentSlide = splide.Components.Slides.getAt(splide.index).slide;
				updateGraphicFromSlide(currentSlide, imageEl);
			});

			// Update on slide change
			splide.on("move", (newIndex) => {
				const newSlide = splide.Components.Slides.getAt(newIndex).slide;
				updateGraphicFromSlide(newSlide, imageEl);
			});

			splide.mount();
		}
	}

	
}


export function setupCarousel(){

	const carousel = document.querySelector("#videoCarousel");
	if (carousel){
		const carouselInstance = new bootstrap.Carousel(carousel);
		const slides = document.querySelectorAll(".carousel-item");
		window.timeoudID = null;
	
		// Store player instances per iframe
		const playerMap = new WeakMap();
	
		const moveToNextSlide = (currentSlide, delay) => {
			let currentIndex = 0;
			if (currentSlide){
				currentIndex = [...slides].indexOf(currentSlide);
			}
			window.timeoudID = setTimeout(() => {
				if (currentIndex === slides.length - 1) {
					carouselInstance.to(0);
				} else {
					carouselInstance.next();
				}
			}, delay);
		
		};

		const processSlide = (currentSlide) => {
		
			const iframe = currentSlide.querySelector(".vimeo_iframe");
			const bannerContent = document.querySelector(".banner-content");
			clearTimeout(window.timeoudID);
			// Show banner content if there's no video
			if (!iframe) {
				bannerContent.style.opacity = "100%";
				moveToNextSlide(currentSlide, 4000);
				return;
			}

			// Hide content
			bannerContent.style.opacity = "0%";
			// Use cached player or create a new one
			let player = playerMap.get(iframe);
			if (!player) {
				const vimeoId = iframe.getAttribute("id");

				const options = {
					id: vimeoId,
					// background: true,
					progress_bar: false,
				};

				player = new Player(iframe, options);
				playerMap.set(iframe, player);

				// Bind 'ended' only once
				player.on("ended", () => {
					moveToNextSlide(currentSlide, 0);
				});
			}

			// Start playback after slight delay
			setTimeout(() => {
				player.setCurrentTime(0).then(() => {
					player.play();
				}).catch(err => console.error("Error playing video:", err));
			}, 1500);
		};

		carousel.addEventListener("slide.bs.carousel", event => {
			processSlide(event.relatedTarget);	
		});
		// src="https://player.vimeo.com/video/${banner_item.content_identifier}?autoplay=1&muted=1&background=0"
		processSlide(slides[0]);
	}
}

export function setupMapClick(){
	const map_click_list = document.querySelectorAll("#map-click, .map-click");
	if (map_click_list) {
		map_click_list.forEach((map_click) => {
			map_click.addEventListener("click", () => {
				// shield the map on mobile for easy scrolling
				map_click.style.display = "none";
			});
		});
	}
}


export function setupOfferSlider(){
	var offerSlider = document.querySelectorAll(".offer-slider");
	
	if(offerSlider){
		for (var i = 0; i < offerSlider.length; i++ ) {
			var slider = offerSlider[i].querySelector(".slider");
			if (slider){
				const splide = new Splide( slider, {
					type   : "slide",
					perPage: 2,
					perMove: 1,
					rewind    : true,
					pagination: false,
					arrows    : true,
					autoplay: true,
					gap: "30px",
					padding: "10%",
					breakpoints: {
						992: {
							perPage: 1,
						},
						768: {
							perPage: 1,
						},
						350: {
							arrows: false,
						}
					},
				});

				const bar = splide.root.querySelector( ".my-slider-progress-bar" );
  
				// Updates the bar width whenever the carousel moves:
				splide.on( "mounted move",  () => {
					const end  = splide.Components.Controller.getEnd() + 1;
					const rate = Math.min( ( splide.index + 1 ) / end, 1 );
					bar.style.width = String( 100 * rate ) + "%";
				} );

				splide.mount();
			}
		
		}
	}
}





export function isElementScrolledPast(el) {
	const rect = el.getBoundingClientRect();
	return rect.bottom < 0;
}


export function setupAutoHideMenu(){
	let lastScrollTop = 0;
	const menu = document.querySelector("#header-wrap");
	const splash_section = document.querySelector("#splash-wrap");
	menu.style.top = "0px";
	// const toggler = splash_section.querySelector(".navbar-toggler-icon");
	// const logo_mobile = splash_section.querySelector("#logo-mobile");
	window.addEventListener("scroll", () => {
		if (fullMenuIsOpen){
			menu.style.top = "0px";
		}
		else{
			let scrollTop = window.scrollY || document.documentElement.scrollTop;
			if (isElementScrolledPast(splash_section)){
				if (scrollTop > lastScrollTop) {
				// Scrolling down
					menu.style.top = "-200px"; // Hide menu
				} else {
				// Scrolling up
					menu.style.top = "0px";
				}
				lastScrollTop = scrollTop;

			}
		}
		
	});
}


window.addEventListener("DOMContentLoaded", init);